import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularResizeElementDirection, AngularResizeElementEvent } from 'angular-resize-element';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { DashboardService } from 'src/app/services/dashboard.service';
import { FilterService } from 'src/app/services/filter.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { AlertViewService } from './alert-view.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import _ from 'lodash';

@Component({
  selector: 'app-alert-view',
  templateUrl: './alert-view.component.html',
  styleUrls: ['./alert-view.component.scss']
})
export class AlertViewComponent implements OnInit, OnChanges {

  @Input("offcanvasRightAlertView") offcanvasRightAlertView:any;
  @Input("alertIndication") alertIndication:any;
  
  @Output("onResizeSideWindow") onResizeSideWindow = new EventEmitter<any>();
  
  public readonly AngularResizeElementDirection = AngularResizeElementDirection;
  public data: any = {};
  reqSubcription: Subscription[] = [];
  moment = moment;
  searchAlertText:any;
  alert_notification:any = [];
  alert_notification_backup:any = [];
  dashboardKey:any;
  loadAlertApi = false;
  moduleKey:any;

  get isModuleKeyExcludedNewAlerts(): boolean {
    if (typeof this.moduleKey === "string") {
      this.moduleKey = Number(this.moduleKey);
    }
    return [100110,100114].includes(this.moduleKey);
    // [100108,100110,100114].includes(this.moduleKey);
    return true;
  }
  

  constructor(
    private route: Router,
    private router: ActivatedRoute,
    private navigationService: NavigationService,
    private filterService: FilterService,
    private dashboardService: DashboardService,
    private alertViewService: AlertViewService,
    private sanitizer: DomSanitizer
  ) { 
    this.router.params.subscribe((p: any) => {

      // Query Params
      this.router.queryParams.subscribe((params:any) => {
        let decryptedParams = this.navigationService.decryptData(params);
        this.dashboardKey = decryptedParams?.["ds_key"];
        this.moduleKey = decryptedParams?.["md_key"];
      })
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['alertIndication'].currentValue != changes['alertIndication'].previousValue) {
      this.loadAlertApi = false;
      this.getAlertsNotificationData();
    }
  }

  ngOnInit(): void {}

  extractBodyIfHtml(html: string): string {
    const isHtml = /<\/?(html|body|div|style|table|tr|td|span|head|script)[^>]*>/i.test(html);
    if (!isHtml) {
      return html; // Plain text, return as-is
    }

    const bodyMatch = html.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
    return bodyMatch ? bodyMatch[1] : html;
  }

  getSafeBodyHtml(fullHtml: string): SafeHtml {
    const parser = new DOMParser();
    const doc = parser.parseFromString(fullHtml, 'text/html');
    const bodyHtml = doc.body.innerHTML;
    return this.sanitizer.bypassSecurityTrustHtml(bodyHtml);
  }

  getAlertsNotificationData() {
    if(this.filterService.baseQuery==null) return;
    if(this.filterService.isEmptyObject(this.filterService.baseQuery)) return;
    let postdata: any = { "api_key": "100410", "report_typ": "D", module_key: this.moduleKey };
    
    let obj = Object.assign({}, this.filterService.baseQuery, postdata);

    this.reqSubcription.push(this.filterService.alertNotificationFilter(obj).subscribe((res: any) => {
      this.alert_notification_backup = [];
      if(res?.length>0) {
        let alertPages = res ? res : [];
        const enrichedPages = alertPages.map((page:any) => ({
          ...page,
          safeHtml: this.getSafeBodyHtml(this.extractBodyIfHtml(page.alert_desc)),
          alert_combination: page.alert_nm + " - " + page.source_name
        }));
        this.alert_notification_backup = enrichedPages;
        this.alert_notification = this.aggAlertSearch(this.alert_notification_backup);
        if(!this.isModuleKeyExcludedNewAlerts) {
          this.alert_notification = [...this.alert_notification_backup]
        }
      }

      this.loadAlertApi = true;
      this.unreadLoadApi(this.dashboardKey);
    }, err => {
      this.loadAlertApi = false;
      this.alert_notification = [];
      this.alert_notification_backup = [];
    }));
  }

  unreadLoadApi(dashboardKey:any) {
    let postdata: any = {
      "report_typ": "I",
      "module_key": this.dashboardService.moduleKey,
      "dashboard_key": dashboardKey,
      "brand_key" : this.filterService?.baseQuery?.brand_key,
    };

    this.reqSubcription.push(this.alertViewService.alertsQuery(postdata).subscribe((res: any) => {
    }, (err:any) => {
    }));
  }

  trackByFnMessage(index: number): number {
    return index;
  }

  public onResizeSide(evt: AngularResizeElementEvent): void {
    this.data.width = evt.currentWidthValue;
    this.data.height = evt.currentHeightValue;
    this.data.top = evt.currentTopValue;
    this.data.left = evt.currentLeftValue;
    this.onResizeSideWindow.emit(this.data);
  }

  @HostListener("window:resize", ["$event"])
  onResize(event: Event) {
    this.checkOrientation();
  }

  checkOrientation() {
    this.data.width = 320;
    this.onResizeSideWindow.emit(this.data);
  }

  onFilterTextBoxChanged() { 
    this.alert_notification = this.aggAlertSearch(this.alert_notification_backup)
    if(!this.isModuleKeyExcludedNewAlerts) {
      this.alert_notification = [...this.alert_notification_backup]
    }
  }
  
  filterMessagesByKeys(messages: any[], searchText: string, keys: string[]): any[] {
    if (!searchText || !Array.isArray(messages) || !Array.isArray(keys)) {
      return messages;
    }

    const lowerSearch = searchText.toLowerCase();

    return messages.filter(obj => 
      keys.some(key => 
        obj[key] && obj[key].toString().toLowerCase().includes(lowerSearch)
      )
    );
  }

  aggAlertSearch(enrichedPages: any) {
    // Filter by search text
    let fields = ['alert_desc', 'alert_nm', 'source_name', "alert_combination"];
    const filtered = this.filterMessagesByKeys(enrichedPages, this.searchAlertText, fields);
    if (!filtered?.length) return [];

    // Group by alert_nm + source_name
    const grouped = _.groupBy(filtered, (page) => `${page.alert_nm}__${page.source_name}`);

    return Object.entries(grouped).map(([key, pages]) => {
      const [alert_nm, source_name] = key.split('__');

      // Group each alert group further by time bucket
      const alertsByDateGroup = _.groupBy(pages, (alert: any) => {
        const alertDate = moment(alert.alert_dt);
        const now = moment();
        const diff = now.diff(alertDate, 'days');

        if (diff === 0) return 'Today';
        if (diff === 1) return 'Yesterday';
        if (diff <= 3) return 'Less than 3 days';
        if (diff <= 7) return 'Less than 7 days';
        if (diff <= 15) return 'Less than 15 days';
        if (diff > 15) return 'Older';
        return null; // Exclude if older
      });

      // Remove null (older data)
      Object.keys(alertsByDateGroup).forEach((k) => {
        if (!k) delete alertsByDateGroup[k];
      });

      return {
        alert_nm,
        source_name,
        groupedAlerts: Object.entries(alertsByDateGroup).map(([label, alerts]) => ({
          label,
          alerts
        }))
      };
    });
  }

  findBorderColor(page:any) {
    let findColor = this.alertColor.find((f:any)=> page.alert_nm == f.col_value);
    if(findColor) {
      return findColor.color || "rgb(210, 210, 210)";
    }
    return  "rgb(210, 210, 210)";
  }

  alertColor = [
    {
      "col_value": "Status Changes",
      "icon": "status_change",
      "color": "#fb983c"
    },
    {
      "col_value": "New Patient",
      "icon": "new_patient",
      "color": "#e34071"
    },
    {
      "col_value": "New Prescriber",
      "icon": "new_prescriber",
      "color": "#3ac97c"
    },
    {
      "col_value": "Refill Too Soon",
      "icon": "refill_alerts",
      "color": "#4833e6"
    },
    {
      "col_value": "Shipment Delayed",
      "icon": "delayed_alert",
      "color": "#db006a"
    },
    {
      "col_value": "Quantity Shipped",
      "icon": "refill_alerts",
      "color": "#3AC97C"
    },
    {
      "col_value": "Shipments"
    },
    {
      "col_value": "Discontinued Patients",
      "icon": "alert_discontinued_patient",
      "color": "#f67180",
    },
    {
      "col_value": "Cancelled Patients",
      "icon": "alert_cancelled_patient",
      "color": "#f8b194"
    },
    {
      "col_value": "Missing Files",
      "icon": "alert_missing_file",
      "color": "#ff509a",
    },
    {
      "col_value": "Competitor NDC",
      "icon": "alert_new_competitor",
      "color": "#1875e3"
    },
    {
      "col_value": "PA Appeal Denied",
      "icon": "alert_pa_appeal_denied",
      "color": "#ff0066"
    },
    {
      "col_value": "Transfers",
      "icon": "alert_transfers",
      "color": "#8c23e6"
    },
    {
      "col_value": "FRM Status Changes",
      "color": "#7458E7",
      "icon": "status_change"
    }
  ]
}
